<template>
  <div :class="$style.registrationHeader">
    <h2>Create Account</h2>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

/**
 * Renders header component for desktop layout.
 */
@Component()
export default class DesktopRegistrationHeader extends Vue {
}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";
.registrationHeader {
  padding: 7px 0;
  background-color: $title-black;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  h2 {
    font-size: 20px;
    color: $white;
    text-transform: uppercase;
  }

  @media ( max-width: $mobile-breakpoint-max ) {
    height: auto;

    h2 {
      font-size: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/desktop/components/DesktopRegistrationHeader.vue